import { ReactNode } from "react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";

interface LandingLayoutProps {
  children: ReactNode;
}

/**
 * LandingLayout - Wraps landing page content with the Navigation and Footer
 * This component should be used for the landing/marketing pages.
 * IMPORTANT: Do not include Navigation or Footer in individual page components.
 */
export const LandingLayout = ({ children }: LandingLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col relative" style={{ backgroundColor: '#F8F9FE' }}>
      {/* Mesh gradient blobs — scroll with page */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div className="absolute top-[5%] -left-[10%] w-[60%] h-[800px] rounded-full opacity-[0.07]" style={{ background: 'radial-gradient(ellipse, #6366f1, transparent 70%)' }} />
        <div className="absolute top-[15%] -right-[15%] w-[50%] h-[700px] rounded-full opacity-[0.05]" style={{ background: 'radial-gradient(ellipse, #8b5cf6, transparent 70%)' }} />
        <div className="absolute top-[40%] -left-[5%] w-[45%] h-[600px] rounded-full opacity-[0.05]" style={{ background: 'radial-gradient(ellipse, #a78bfa, transparent 70%)' }} />
        <div className="absolute top-[55%] -right-[10%] w-[55%] h-[700px] rounded-full opacity-[0.06]" style={{ background: 'radial-gradient(ellipse, #6366f1, transparent 70%)' }} />
        <div className="absolute top-[75%] left-[10%] w-[40%] h-[600px] rounded-full opacity-[0.04]" style={{ background: 'radial-gradient(ellipse, #8b5cf6, transparent 70%)' }} />
      </div>
      <Navigation />
      <main className="flex-1 relative z-[1]">
        {children}
      </main>
      <Footer />
    </div>
  );
}; 
 